import React, { useState, useEffect } from "react";
import AnimatedHeader from "../animatedLetters/AnimatedHeader";
import { AboutPage } from "./aboutStyle";
import headShot from "../../assets/hey.png";
import Loader from "../loading/Loader";
import useElementOnScreen from "../../utils/useElementOnScreen";

const About = () => {
  const [itemRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 0.05,
  });

  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    if (!spinner) {
      setSpinner(false);
    }
    // eslint-disable-next-line
  }, [spinner]);

  const loadTime = (loader) => {
    setSpinner(loader);
  };

  return (
    <>
      {spinner ? (
        <Loader loadTime={loadTime} />
      ) : (
        <AboutPage isVisible={isVisible}>
          <div className="text-zone">
            <h1>
              <AnimatedHeader
                letterClass={"text-animate-hover"}
                strArray={["A", "b", "o", "u", "t", " ", "m", "e"]}
                idx={30}
              />
            </h1>
            <p>
              I'm an enthusiastic software engineer, I am passionate about
              technology and have a strong background in software engineering. I
              am a hardworking and dedicated individual, looking for a role in
              established product team with the opportunity to work with the
              latest technologies on challenging and diverse projects.
            </p>
            <br />
            <p align="LEFT">
              I'm quietly confident, naturally curious, I love to create smart
              user interfaces and imagine useful interactions, developing rich
              web experiences & web applications.
            </p>
            <br />
            <p>
              When I'm not writing programs, I can be found playing board games,
              reading, engaging in social gatherings, exercising or taking a
              walk to stay fit.
            </p>
          </div>
          <div className="profile-img" ref={itemRef}>
            <div className="profile-element">
              <img src={headShot} alt="" />
            </div>
          </div>
        </AboutPage>
      )}
    </>
  );
};

export default About;
